/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import LockIcon from "@mui/icons-material/Lock";

const UserLockModal = ({ open, user, isSubmit, userLock, onClose }) => {
  return (
    <Dialog open={open} PaperProps={{ style: { borderRadius: "10px" } }}>
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to Lock {user}?
      </DialogTitle>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="error">
          Cancel
        </Button>
        <LoadingButton
          loading={isSubmit}
          loadingPosition="start"
          startIcon={<LockIcon />}
          variant="contained"
          color="success"
          onClick={userLock}>
          Lock
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default UserLockModal;
